if (!customElements.get('dog-customization')) {
  class DogCustomization extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.mode = this.querySelector('[data-dog-mode]');
      this.fields = this.querySelector('[data-dog-fields]');
      this.photo = this.querySelector('[data-dog-photo]');
      this.preview = this.querySelector('[data-dog-preview]');
      this.status = this.querySelector('[data-dog-status]');
      this.mode.disabled = false;
      this.mode.addEventListener('change', () => this.updateMode());
      this.photo.addEventListener('change', () => this.updatePhoto());
      this.updateMode();
    }

    updateMode() {
      const custom = this.mode.value === 'Custom dog silhouette';
      this.fields.hidden = !custom;
      this.fields.disabled = !custom;
      this.photo.required = custom;
      if (!custom) {
        this.photo.value = '';
        this.photo.setCustomValidity('');
        this.clearPreview();
        this.message('');
      }
    }

    clearPreview() {
      this.previewToken = (this.previewToken || 0) + 1;
      if (this.previewURL) URL.revokeObjectURL(this.previewURL);
      this.previewURL = null;
      this.preview.hidden = true;
      this.preview.removeAttribute('src');
    }

    message(text, error = false) {
      this.status.textContent = text;
      this.status.toggleAttribute('data-error', error);
    }

    async updatePhoto() {
      this.clearPreview();
      this.photo.setCustomValidity('');
      const file = this.photo.files?.[0];
      if (!file) { this.message(''); return; }
      let error = '';
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) error = 'Please choose a JPG, PNG or WebP photo.';
      else if (file.size > 10 * 1024 * 1024) error = 'Please choose a photo smaller than 10 MB.';
      if (error) {
        this.photo.setCustomValidity(error);
        this.message(error, true);
        return;
      }
      const token = this.previewToken;
      this.photo.setCustomValidity('Please wait while we check your photo.');
      this.message('Checking your photo…');
      this.previewURL = URL.createObjectURL(file);
      this.preview.src = this.previewURL;
      try {
        await this.preview.decode();
        if (token !== this.previewToken) return;
        this.preview.hidden = false;
        this.photo.setCustomValidity('');
        this.message(file.name + ' selected. Your photo will be uploaded when you add this item to your cart.');
      } catch {
        if (token !== this.previewToken) return;
        this.clearPreview();
        const message = 'This photo could not be opened. Please choose a different JPG, PNG or WebP file.';
        this.photo.setCustomValidity(message);
        this.message(message, true);
      }
    }

    disconnectedCallback() { this.clearPreview(); }
  }
  customElements.define('dog-customization', DogCustomization);
}
